import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Redirect } from 'react-router-dom'
import { useIntl, FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils'
import {
  Collapse,
  TextField,
  CircularProgress,
  Grid,
  Box,
  Select,
  NativeSelect,
  InputLabel,
  MenuItem,
  FormControl,
} from '@material-ui/core';
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { StyledSelect } from '../../commons/utils/TableStyles'
import * as Constants from '../atributoDinamico/constants.js'
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";
import Security from "../../commons/security/Security.js";


const FILTER_STATE_INIT = {
  icono: '',
  estado: null,
  id: '',
  descripcion: '',
  fecha: '',
  entidad: '',
  unidad: [],
  vin: '',
  usuario: '',
  fallas: '',
  base: [],
  subRegion: [],
  pais: null,
  chofer: '',
  showInactivos: false,
  transportadora: [],
  rentadora: []
};

const getFilterState = () => {
  let filterStateInit = JSON.parse(JSON.stringify(FILTER_STATE_INIT));
  let file = JSON.parse(window.localStorage.getItem('FormulariosGridFilters'));
  if (file && file.activo && file.userFilters) {
    filterStateInit = file.userFilters
  }

  return filterStateInit
}

const getPersisteStoragedState = () => {
  let file = JSON.parse(window.localStorage.getItem('FormulariosGridFilters'));
  return (file && file.activo)
}

const FormulariosGridFilters = (props) => {
  const intl = useIntl();
  const [init, setInit] = useState(false)
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [filtersState, setFiltersState] = useState(getFilterState);
  const [persisteFiltros, setPersisteFiltros] = useState(getPersisteStoragedState);
  const [bases, setBases] = useState([]);
  const [subRegiones, setSubRegiones] = useState([]);
  const [paises, setPaises] = useState([]);
  const [transportadoras, setTransportadoras] = useState([]);
  const [rentadoras, setRentadoras] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [unidadesLoading, setUnidadesLoading] = useState(false);
  const unidadesDebounceRef = useRef(null);
  const [validatorSearch, setValidatorSearch] = useState(false)
  const estados = props.estados
  const columnsEnabled = props.columnsEnabled

  columnsEnabled.pais = ConfigBusiness.get("checklist.pais.habilitado") === 'true' ? true : false;


  useEffect(() => {
    if (init === false) {
      props.setSearchActive(true);
      setPersisteFiltros(true);
      let query = JSON.parse(JSON.stringify(filtersState));
      query['estado'] = query['estado'] ? query['estado']['value'] : ''
      query['base'] = query['base'] ? query['base'].map(e => e.value).join(',') : ''
      query['subRegion'] = query['subRegion'] ? query['subRegion'].map(e => e.value).join(',') : ''
      query['pais'] = query['pais'] ? query['pais']['value'] : ''
      query['transportadora'] = query['transportadora'] ? query['transportadora'].map(e => e.id).join(',') : ''
      query['rentadora'] = query['rentadora'] ? query['rentadora'].map(e => e.id).join(',') : ''
      query['unidad'] = Array.isArray(query['unidad']) && query['unidad'].length > 0 ? query['unidad'].join(',') : ''
      //control filtro por url. Alert Checklist (Preventivo)
      if(props.filterEntidad){
        query['entidad'] = props.filterEntidad
        setFiltersState({ ...filtersState, entidad: props.filterEntidad })
      }
      
      props.setFilterQuery(query);
      setInit(true)
    }

    // Cambios "colaterales" al estado de persisteFiltros
    if (persisteFiltros) {
      props.setSearchActive(true);

    } else {
      props.setSearchActive(false);
      setFiltersState(FILTER_STATE_INIT)
      props.setDropdownActive(false)
    }

    window.localStorage.setItem('FormulariosGridFilters', JSON.stringify({ activo: persisteFiltros, userFilters: filtersState }));
  }, [persisteFiltros])

  useEffect(() => {
    props.dropdownActive && fetchData()
    !props.dropdownActive && props.setResetFilterInputs(false)
  }, [props.dropdownActive]);

  useEffect(() => {
    if (props.resetFilterInputs) {
      setFiltersState(FILTER_STATE_INIT)
      setPersisteFiltros(false)
    }
  }, [props.resetFilterInputs]);


  const fetchData = () => {
    Utils.getData('/paises/select').then((paises) => {
      setPaises(paises)

    }).catch((err) => {
      console.log(err);
    })
    Utils.getData('/bases/select-filtered-by-user')
      .then((bases) => {
        setBases(bases)
      }).catch((err) => {
        console.log(err);
      })
      Utils.getData('/subregiones/select-all')
      .then((subregion) => {
        setSubRegiones(subregion)

      }).catch((err) => {
        console.log(err);
      })
    Utils.getData('/transportadoras/select')
    .then((transportadoras) => {
      setTransportadoras(transportadoras)
    }).catch((err) => {
      console.log(err);
    })
    Utils.getData('/rentadoras/select')
    .then((rentadoras) => {
      setRentadoras(rentadoras)
    }).catch((err) => {
      console.log(err);
    })
  }

  const fetchUnidades = (q) => {
    if (!q) {
      setUnidades([]);
      return;
    }
    setUnidadesLoading(true);
    Utils.getData('/formulario/unidades?q=' + encodeURIComponent(q))
      .then((data) => setUnidades(data))
      .catch((err) => console.log(err))
      .finally(() => setUnidadesLoading(false));
  };

  const handleChange = (name, object) => {
    console.log("handleChange - name:", name, "object:", object);
    console.log(props.persisteFiltros);
    try {
      setFiltersState((prevState) => {
        const updatedFiltersState = { ...prevState, [name]: object };                
        return updatedFiltersState;
      });
    } catch (error) {
      console.error("Error al manejar el cambio de filtros:", error);
    }
  };

  const handleChangeInactivosSwich = (value) => {
    setFiltersState({...filtersState, showInactivos : value});
    handleChange('showInactivos', value);
  };

  const handleOnEnter = (e, name, value) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleChange(name, value);
    }
  };

  const queryTable = () => {
    let query = {}
    query = JSON.parse(JSON.stringify(filtersState));
    query['base'] = filtersState.base ? filtersState.base.map(e => e.value).join(',') : ''
    query['chofer'] = filtersState.chofer ? filtersState.chofer : ''
    query['descripcion'] = filtersState.descripcion ? filtersState.descripcion : ''
    query['entidad'] = filtersState.entidad ? filtersState.entidad : ''
    query['unidad'] = Array.isArray(filtersState.unidad) && filtersState.unidad.length > 0 ? filtersState.unidad.join(',') : ''
    query['vin'] = filtersState.vin ? filtersState.vin : ''
    query['estado'] = filtersState.estado ? filtersState.estado.value : ''
    query['fallas'] = filtersState.fallas ? filtersState.fallas : ''
    query['fecha'] = filtersState.fecha ? filtersState.fecha : ''
    query['icono'] = filtersState.icono ? filtersState.icono : ''
    query['id'] = filtersState.id ? filtersState.id : ''
    query['pais'] = filtersState.pais ? filtersState.pais.value : ''
    query['rentadora'] = filtersState.rentadora ? filtersState.rentadora.map(e => e.id).join(',') : '';
    query['subRegion'] = filtersState.subRegion ? filtersState.subRegion.map(e => e.value).join(',') : '';
    query['transportadora'] = filtersState.transportadora ? filtersState.transportadora.map(e => e.id).join(',') : '';
    query['usuario'] = filtersState.usuario ? filtersState.usuario : '';
    return query;
  }
  
  const validator = () => {
		var result = Object.entries(filtersState);
		for (var index in result){
			if(Array.isArray(result[index][1])){
				if(result[index][1].length > 0 ){
					return false
				}
			}else{
				if(result[index][1]){
					return false
				}
			}
		}
		return true
	}

  useEffect(() => {
    setValidatorSearch(validator());
  },[filtersState])

  const onChangePersistentFilter = (value) => {
    if (props.persisteFiltros) {
      window.localStorage.setItem('FormulariosGridFilters', JSON.stringify({activo: value, userFilters: filtersState}));
    }
  }

  const handleSubmitInto = (event) => {
		if(!props.loading && !validatorSearch){
			handleSubmit(event);
		}
		event.preventDefault();
	}

  const handleSubmit = (event) => {
    onChangePersistentFilter(true);
    props.onFilterChange();
    event.preventDefault();
    props.setSearchActive(true)
    let query = queryTable();
    props.setFilterQuery(query);
    return;
  }

  return (
    <>
      {init && (
        <Collapse in={props.dropdownActive}>
          <Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
            <Grid {...(!columnsEnabled.id && { display: 'none' })} component={Box} item xs={1}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_id.label',
                    defaultMessage: 'Id',
                  })}
                  name="id"
                  value={filtersState.id}
                  onChange={(e) => {handleChange('id', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid
              {...(!columnsEnabled.descripcion && { display: 'none' })}
              component={Box}
              item
              xs={3}
            >
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_descripcion.label',
                    defaultMessage: 'Descripcion',
                  })}
                  name="descripcion"
                  value={filtersState.descripcion}
                  onChange={(e) => {handleChange('descripcion', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.fecha && { display: 'none' })} component={Box} item xs={2}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_fecha.label',
                    defaultMessage: 'Fecha',
                  })}
                  name="fecha"
                  value={filtersState.fecha}
                  onChange={(e) => {handleChange('fecha', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                  type="date"
                  // isClearable={true}
                  format={'DD-MM-YYYY'}
                  // disableFuture
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.entidad && { display: 'none' })} component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_entidad.label',
                    defaultMessage: 'Entidad',
                  })}
                  name="entidad"
                  value={filtersState.entidad}
                  onChange={(e) => {handleChange('entidad', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="unidad"
                  multiple={true}
                  disabled={filtersLoading}
                  options={unidades}
                  defaultValue={[]}
                  value={Array.isArray(filtersState.unidad) ? filtersState.unidad : []}
                  getOptionLabel={(option) => (option ? option : '')}
                  filterOptions={(x) => x}
                  loading={unidadesLoading}
                  noOptionsText={intl.formatMessage({ id: 'formulariosGridFilters.render.filtros_unidad.noOptions', defaultMessage: 'Escribí para buscar' })}
                  onInputChange={(e, value) => {
                    clearTimeout(unidadesDebounceRef.current);
                    unidadesDebounceRef.current = setTimeout(() => fetchUnidades(value), 300);
                  }}
                  onChange={(e, value) => {handleChange('unidad', value)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGridFilters.render.filtros_unidad.label',
                        defaultMessage: 'Unidad',
                      })}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {unidadesLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_vin.label',
                    defaultMessage: 'VIN',
                  })}
                  name="vin"
                  value={filtersState.vin}
                  onChange={(e) => {handleChange('vin', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.usuario && { display: 'none' })} component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_usuario.label',
                    defaultMessage: 'Usuario',
                  })}
                  name="usuario"
                  value={filtersState.usuario}
                  onChange={(e) => {handleChange('usuario', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.fallas && { display: 'none' })} component={Box} item xs={1}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_fallas.label',
                    defaultMessage: 'Fallas',
                  })}
                  name="fallas"
                  value={filtersState.fallas}
                  onChange={(e) => {handleChange('fallas', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid {...((!columnsEnabled.chofer || Security.hasPermission('USUARIO_ACTUAR_COMO_CHOFER')) && { display: 'none' })} component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <TextField
                  label={intl.formatMessage({
                    id: 'formulariosGridFilters.render.filtros_chofer.label',
                    defaultMessage: 'Chofer',
                  })}
                  name="chofer"
                  value={filtersState.chofer}
                  onChange={(e) => {handleChange('chofer', e.target.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.icono && { display: 'none' })} component={Box} item xs={1}>
              <FormControl>
                <InputLabel id="input-tipo-label">
                  <FormattedMessage
                    id="formulariosGridFilters.render.filtros_tipo_formulario.label"
                    defaultMessage="Tipo"
                  />
                </InputLabel>
                <Select
                  labelId="input-tipo-label"
                  name="icono"
                  value={filtersState.icono}
                  onChange={(e, value) => {handleChange('icono', value.props.value)}}
                  disabled={filtersLoading}
                  className="col-12"
                  style={{ fontSize: '0.7em' }}
                >
                  <MenuItem value="">TODOS</MenuItem>
                  <MenuItem value="fa fa-bus">
                    <i className="fa-2x fa fa-bus"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-motorcycle">
                    <i className="fa-2x fa fa-motorcycle"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-car">
                    <i className="fa-2x fa fa-car"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-truck">
                    <i className="fa-2x fa fa-truck"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-user">
                    <i className="fa-2x fa fa-user"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-users">
                    <i className="fa-2x fa fa-users"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-wrench">
                    <i className="fa-2x fa fa-wrench"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-cog">
                    <i className="fa-2x fa fa-cog"></i>
                  </MenuItem>
                  <MenuItem value="fa fa-map-marker">
                    <i className="fa-2x fa fa-map-marker"></i>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid component={Box} item xs={2}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="estado"
                  disabled={filtersLoading}
                  options={estados}
                  value={filtersState.estado}
                  getOptionLabel={(option) => (option ? option.label : '')}
                  onChange={(e, value) => {handleChange('estado', value)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGrid.render.filtros_estado.label',
                        defaultMessage: 'Estado',
                      })}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="base"
                  multiple={true}
                  disabled={filtersLoading}
                  options={bases}
                  defaultValue={[]}
                  value={filtersState.base}
                  getOptionLabel={(option) => (option ? option.label : '')}
                  onChange={(e, value) => {handleChange('base', value)}}
                  onKeyDown={(e) => handleOnEnter(e, 'base', filtersState.base)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGrid.render.filtros_base.label',
                        defaultMessage: 'Base',
                      })}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="subRegion"
                  multiple={true}
                  disabled={filtersLoading}
                  options={subRegiones}
                  defaultValue={[]}
                  value={filtersState.subRegion ? filtersState.subRegion : []}
                  getOptionLabel={(option) => (option ? option.label : '')}
                  onChange={(e, value) => {handleChange('subRegion', value)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGrid.render.filtros_subRegion.label',
                        defaultMessage: 'Subregion',
                      })}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.transportadora && { display: 'none' })} component={Box} item xs={2}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="transportadora"
                  multiple={true}
                  disabled={filtersLoading}
                  options={transportadoras}
                  defaultValue={[]}
                  value={filtersState.transportadora ? filtersState.transportadora : []}
                  getOptionLabel={(option) => (option ? option.nombre : '')}
                  onChange={(e, value) => {handleChange('transportadora', value)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGrid.render.filtros_transportadora.label',
                        defaultMessage: 'Transportadora',
                      })}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.rentadora && { display: 'none' })} component={Box} item xs={2}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="rentadora"
                  multiple={true}
                  disabled={filtersLoading}
                  options={rentadoras}
                  defaultValue={[]}
                  value={filtersState.rentadora ? filtersState.rentadora : []}
                  getOptionLabel={(option) => (option ? option.descripcion : '')}
                  onChange={(e, value) => {handleChange('rentadora', value)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGrid.render.filtros_rentadora.label',
                        defaultMessage: 'Rentadora',
                      })}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid {...(!columnsEnabled.pais && { display: 'none' })} component={Box} item xs={3}>
              <form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
                <Autocomplete
                  size="small"
                  name="pais"
                  disabled={filtersLoading}
                  options={paises}
                  value={filtersState.pais}
                  getOptionLabel={(option) => (option ? option.label : '')}
                  onChange={(e, value) => {handleChange('pais', value)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={intl.formatMessage({
                        id: 'formulariosGrid.render.filtros_pais.label',
                        defaultMessage: 'Pais',
                      })}
                    />
                  )}
                />
              </form>
            </Grid>
            <Grid
              xs={12}
              container
              alignItems="center"
              flexDirection={{ xs: 'column', sm: 'row' }}
              sx={{ fontSize: '12px' }}
            >
              <Grid component={Box} item xs="auto" className="align-self-end" style={{ paddingRight: 20 }}>
                <form noValidate autoComplete="off">
                  <div className="d-flex align-items-center" style={{ gap: 8 }}>
                    <FormattedMessage
                      id="formulariosGridFilters.render.filtros.ver_inactivos"
                      defaultMessage="Ver Inactivos"
                    />
                    <Switch
                      onChange={(value) => handleChangeInactivosSwich(value)}
                      checked={filtersState.showInactivos}
                      disabled={filtersLoading}
                      offColor="#FF4961"
                      onColor="#28D094"
                    />
                  </div>
                </form>
              </Grid>
              <Grid component={Box} item xs="auto" className="align-self-end" style={{ paddingRight: 20 }}>
                <form noValidate autoComplete="off">
                  <div className="d-flex align-items-center" style={{ gap: 8 }}>
                    <FormattedMessage
                      id="formulariosGridFilters.render.filtros.persistir_filtros"
                      defaultMessage="Persistir Filtros"
                    />
                    <Switch
                      onChange={(value) => setPersisteFiltros(value)}
                      checked={persisteFiltros}
                      disabled={filtersLoading}
                      offColor="#FF4961"
                      onColor="#28D094"
                    />
                  </div>
                </form>
              </Grid>
              <Grid component={Box} item style={{ flex: 1 }} />
              <Grid component={Box} item xs="auto" className="align-self-end">
                <button
                  disabled={props.loading}
                  className="btn btn-primary mr-1"
                  onClick={(e) => handleSubmit(e)}
                >
                  <i className="fa fa-search fa-xs"></i>   <FormattedMessage id="Buscar" defaultMessage="Buscar"/>
                </button>
              </Grid>
            </Grid>
          </Grid>
        </Collapse>
      )}
    </>
  );
}


export default FormulariosGridFilters
